import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "version" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "token-content" }
const _hoisted_5 = { id: "tokenForm" }
const _hoisted_6 = {
  key: 0,
  class: "code-inputs"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "buttons" }

export function render(_ctx, _cache) {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onLogoClick && _ctx.onLogoClick(...args)))
          }, [
            _createVNode(_component_el_image, { src: "/img/ddg-logo-128.png" })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('logo-line' + ((_ctx.windowWidth < 768) ? '-mobile' : ''))
          }, _cache[37] || (_cache[37] = [
            _createTextVNode(" MC.health"),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("Prüfungsplattform ")
          ]), 2),
          _createElementVNode("div", _hoisted_2, " V. " + _toDisplayString(_ctx.environmentVersion), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "token-head" }, "Bitte geben Sie den Code aus der E-Mail Bestätigung ein:", -1)),
        _createElementVNode("form", _hoisted_5, [
          (_ctx.windowWidth >= 982)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_row, { class: "token-row" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      class: "token",
                      span: 1.5
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "token-0",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.tokenArray[0]) = $event)),
                          class: "token",
                          type: "text",
                          maxlength: "1",
                          onInput: _cache[2] || (_cache[2] = $event => (_ctx.onTokenEnter($event, 0))),
                          onKeydown: _cache[3] || (_cache[3] = $event => (_ctx.onKeyDown($event, 0))),
                          autofocus: ""
                        }, null, 544), [
                          [_vModelText, _ctx.tokenArray[0]]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "token",
                      span: 1.5
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "token-1",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.tokenArray[1]) = $event)),
                          class: "token",
                          type: "text",
                          maxlength: "1",
                          onInput: _cache[5] || (_cache[5] = $event => (_ctx.onTokenEnter($event, 1))),
                          onKeydown: _cache[6] || (_cache[6] = $event => (_ctx.onKeyDown($event, 1)))
                        }, null, 544), [
                          [_vModelText, _ctx.tokenArray[1]]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "token",
                      span: 1.5
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "token-2",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.tokenArray[2]) = $event)),
                          class: "token",
                          type: "text",
                          maxlength: "1",
                          onInput: _cache[8] || (_cache[8] = $event => (_ctx.onTokenEnter($event, 2))),
                          onKeydown: _cache[9] || (_cache[9] = $event => (_ctx.onKeyDown($event, 2)))
                        }, null, 544), [
                          [_vModelText, _ctx.tokenArray[2]]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "token",
                      span: 1.5
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "token-3",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.tokenArray[3]) = $event)),
                          class: "token",
                          type: "text",
                          maxlength: "1",
                          onInput: _cache[11] || (_cache[11] = $event => (_ctx.onTokenEnter($event, 3))),
                          onKeydown: _cache[12] || (_cache[12] = $event => (_ctx.onKeyDown($event, 3)))
                        }, null, 544), [
                          [_vModelText, _ctx.tokenArray[3]]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "token",
                      span: 1.5
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "token-4",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.tokenArray[4]) = $event)),
                          class: "token",
                          type: "text",
                          maxlength: "1",
                          onInput: _cache[14] || (_cache[14] = $event => (_ctx.onTokenEnter($event, 4))),
                          onKeydown: _cache[15] || (_cache[15] = $event => (_ctx.onKeyDown($event, 4)))
                        }, null, 544), [
                          [_vModelText, _ctx.tokenArray[4]]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "token",
                      span: 1.5
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "token-5",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.tokenArray[5]) = $event)),
                          class: "token",
                          type: "text",
                          maxlength: "1",
                          onInput: _cache[17] || (_cache[17] = $event => (_ctx.onTokenEnter($event, 5))),
                          onKeydown: _cache[18] || (_cache[18] = $event => (_ctx.onKeyDown($event, 5)))
                        }, null, 544), [
                          [_vModelText, _ctx.tokenArray[5]]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  id: "token-0",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.tokenArray[0]) = $event)),
                  class: "token-mobile",
                  type: "text",
                  maxlength: "1",
                  onInput: _cache[20] || (_cache[20] = $event => (_ctx.onTokenEnter($event, 0))),
                  onKeydown: _cache[21] || (_cache[21] = $event => (_ctx.onKeyDown($event, 0))),
                  autofocus: ""
                }, null, 544), [
                  [_vModelText, _ctx.tokenArray[0]]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "token-1",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.tokenArray[1]) = $event)),
                  class: "token-mobile",
                  type: "text",
                  maxlength: "1",
                  onInput: _cache[23] || (_cache[23] = $event => (_ctx.onTokenEnter($event, 1))),
                  onKeydown: _cache[24] || (_cache[24] = $event => (_ctx.onKeyDown($event, 1)))
                }, null, 544), [
                  [_vModelText, _ctx.tokenArray[1]]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "token-2",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((_ctx.tokenArray[2]) = $event)),
                  class: "token-mobile",
                  type: "text",
                  maxlength: "1",
                  onInput: _cache[26] || (_cache[26] = $event => (_ctx.onTokenEnter($event, 2))),
                  onKeydown: _cache[27] || (_cache[27] = $event => (_ctx.onKeyDown($event, 2)))
                }, null, 544), [
                  [_vModelText, _ctx.tokenArray[2]]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "token-3",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((_ctx.tokenArray[3]) = $event)),
                  class: "token-mobile",
                  type: "text",
                  maxlength: "1",
                  onInput: _cache[29] || (_cache[29] = $event => (_ctx.onTokenEnter($event, 3))),
                  onKeydown: _cache[30] || (_cache[30] = $event => (_ctx.onKeyDown($event, 3)))
                }, null, 544), [
                  [_vModelText, _ctx.tokenArray[3]]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "token-4",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => ((_ctx.tokenArray[4]) = $event)),
                  class: "token-mobile",
                  type: "text",
                  maxlength: "1",
                  onInput: _cache[32] || (_cache[32] = $event => (_ctx.onTokenEnter($event, 4))),
                  onKeydown: _cache[33] || (_cache[33] = $event => (_ctx.onKeyDown($event, 4)))
                }, null, 544), [
                  [_vModelText, _ctx.tokenArray[4]]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "token-5",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => ((_ctx.tokenArray[5]) = $event)),
                  class: "token-mobile",
                  type: "text",
                  maxlength: "1",
                  onInput: _cache[35] || (_cache[35] = $event => (_ctx.onTokenEnter($event, 5))),
                  onKeydown: _cache[36] || (_cache[36] = $event => (_ctx.onKeyDown($event, 5)))
                }, null, 544), [
                  [_vModelText, _ctx.tokenArray[5]]
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "default",
            onClick: _ctx.onReturnClick
          }, {
            default: _withCtx(() => _cache[38] || (_cache[38] = [
              _createTextVNode("Zurück zur Anmeldung")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives(_createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => _cache[39] || (_cache[39] = [
              _createTextVNode("Bestätigen")
            ])),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.showButton]
          ])
        ])
      ])
    ])
  ], 64))
}